/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";

/** @module core/modules/object-utils/add-read-only-property */
import { log } from '../../log.js';
/**
 * @description Adds a read-only like property to an object.
 * @param {Object<string,*>} obj - Input object.
 * @param {string} key - Name for the read-only property to be added.
 * @param {*} value - Value for the added property.
 * @returns {boolean} Result.
 */

function addReadOnlyProperty(obj, key, value) {
  if (typeof obj[key] !== 'undefined') {
    return false;
  }

  _Object$defineProperty(obj, key, {
    /**
     * @description Getter to be assigned.
     * @returns {*} Corresponding property value.
     */
    get: function get() {
      return value;
    },

    /**
     * @description Setter to be assigned.
     * @returns {void} Void.
     */
    set: function set() {
      // TODO: THROW ERROR (CREATE ERROR THROWING/HANDLING UTILITY. INCLUDE IN Log?)
      log.error('addReadOnlyProperty()', 'TRYING TO MODIFY A READ-ONLY PROPERTY')();
    }
  });

  return true;
}

export { addReadOnlyProperty };